'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadLicenseData = loadLicenseData;
exports.loadBridgeLicenseData = loadBridgeLicenseData;

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LICENSE_LOAD = 'ms/license/license_load';
var LICENSE_LOAD_SUCCESS = 'ms/license/license_load_success';
var LICENSE_LOAD_FAIL = 'ms/license/license_load_fail';

var LICENSE_BRIDGE_LOAD = 'ms/license/bridge/load';
var LICENSE_BRIDGE_SUCCESS = 'ms/license/bridge/load_success';
var LICENSE_BRIDGE_FAIL = 'ms/license/bridge/load_fail';

var initialState = {
  licenseInfo: {},
  loadingLicenseError: null,
  loadingLicense: false,

  bridgeLicenseInfo: {},
  loadingBridgeLicenseError: null,
  loadingBridgeLicense: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LICENSE_LOAD:
      return (0, _extends3.default)({}, state, {
        loadingLicense: true,
        loadingLicenseError: null
      });

    case LICENSE_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        licenseInfo: action.result,
        loadingLicense: false,
        loadingLicenseError: null
      });

    case LICENSE_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingLicense: false,
        loadingLicenseError: action.error
      });

    case LICENSE_BRIDGE_LOAD:
      return (0, _extends3.default)({}, state, {
        loadingBridgeLicense: true,
        loadingBridgeLicenseError: null
      });

    case LICENSE_BRIDGE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        bridgeLicenseInfo: action.result,
        loadingBridgeLicense: false,
        loadingBridgeLicenseError: null
      });

    case LICENSE_BRIDGE_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingBridgeLicense: false,
        loadingBridgeLicenseError: action.error
      });

    default:
      return state;
  }
}

// Action creators
function loadLicenseData() {
  return {
    types: [LICENSE_LOAD, LICENSE_LOAD_SUCCESS, LICENSE_LOAD_FAIL],
    promise: loadLicense()
  };
}

function loadBridgeLicenseData() {
  return {
    types: [LICENSE_BRIDGE_LOAD, LICENSE_BRIDGE_SUCCESS, LICENSE_BRIDGE_FAIL],
    promise: loadBridgeLicense()
  };
}

// Private
function loadLicense() {
  return function (client) {
    var loadingPromise = client.post('/v1/payments/license/info/file').then(function (result) {
      (0, _utils.downloadLicenseFile)(result.signature);
    });

    return loadingPromise;
  };
}

function loadBridgeLicense() {
  return function (client) {
    var loadingPromise = client.post('/v1/payments/license/info/file/bridge').then(function (result) {
      (0, _utils.downloadBridgeLicenseFile)(result.signature);
    });

    return loadingPromise;
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/license.js
// module id = 592
// module chunks = 0